import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import {
    setSideMenuState,
    setToggleBarComponent,
    setToggleBarState,
    SIDE_MENU_STATE_OVERVIEW,
    TOGGLE_BAR_STATE_FILTER,
} from '../../store/actions/ui';
import OverviewToggleBar from './OverviewToggleBar';
import MachineSelection from './MachineSelection';
import OverviewFiltersApplied from './OverviewFiltersApplied';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'row',
        height: 'calc(100vh - 115px)',
    },
    machineSelectionSubWindow: {
        width: '414px',
        maxWidth: '414px',
        marginRight: '31px',
    },
    filtersAppliedSubWindow: {
        width: '414px',
        maxWidth: '414px',
        marginRight: '31px',
    },
});

/** Overview filter - selecting which machines to filter by (two inner windows - machine selection and filters applied) */
export default function OverviewFilter(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setToggleBarComponent(OverviewToggleBar));
        dispatch(setToggleBarState(TOGGLE_BAR_STATE_FILTER));
        dispatch(setSideMenuState(SIDE_MENU_STATE_OVERVIEW));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.container}>
            <MachineSelection
                loading={props.loading}
                className={classes.machineSelectionSubWindow}
            />
            <OverviewFiltersApplied
                className={classes.filtersAppliedSubWindow}
                loading={props.loading}
            />
        </div>
    );
}
